<template>
    <div v-show="message" class="alert alert-danger" role="alert">
        <strong>{{ message }}</strong>
    </div>
</template>

<script>
    export default {
        props: ['message']
    }
</script>
